export const dataGruposDrawer = [
  {
    "descripcion": "Ventas",
    "grupo": "ventas",
    "icon": "fa-cash-register",
    "order": 1
  },
  {
    "descripcion": "XML Comprobantes",
    "grupo": "xml",
    "icon": "fa-file-code",
    "order": 2
  },
  {
    "descripcion": "Contratos",
    "grupo": "contratos",
    "icon": "fa-handshake",
    "order": 3
  },
  {
    "descripcion": "Ordenes",
    "grupo": "ordenes",
    "icon": "fa-helmet-safety",
    "order": 4
  },
  {
    "descripcion": "Recursos humanos",
    "grupo": "rrhh",
    "icon": "fa-restroom",
    "order": 5
  },
  {
    "descripcion": "Inventario",
    "grupo": "inventario",
    "icon": "fa-box",
    "order": 6
  },
  {
    "descripcion": "CRM",
    "grupo": "crm",
    "icon": "fa-person-rays",
    "order": 7
  },
  {
    "descripcion": "Cajas",
    "grupo": "caja",
    "icon": "fa-sack-dollar",
    "order": 8
  },
  {
    "descripcion": "Bancos",
    "grupo": "bancos",
    "icon": "fa-vault",
    "order": 9
  },
  {
    "descripcion": "Usuarios",
    "grupo": "usuarios",
    "icon": "fa-solid fa-users-gear",
    "order": 10
  },
  {
    "descripcion": "Configuracion",
    "grupo": "configuracion",
    "icon": "fa-solid fa-gears",
    "order": 11
  },
  {
    "descripcion": "Catálogo",
    "grupo": "catalogo",
    "icon": "fa-store",
    "order": 12
  },
  {
    "descripcion": "Reportes",
    "grupo": "reportes",
    "icon": "fa-solid fa-database",
    "order": 13
  }
]
